import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {createUserWorkflowPayload  } from "../helper/createPayload"
import {val} from "../lib/Scorefield"
export const getGradeforRiskprofile = createAsyncThunk(
  "fetchApi/gradecalculation",
    async (grade,) => {
      const req = `${BASE_URL}/organisation/gradecalculation`;
      
      let body={
        grade:grade
      }

      const options = {
        method: 'POST', 
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body) 
      }
      
  
      try {
        const result = await apiRequest(req, options);
       
        return result
       
      } catch (err) {
        
      }
    }
  );
